export const getPagination = (searchParams: URLSearchParams) => {
  const rawPage = searchParams.get('page')
  const page = rawPage !== null && !isNaN(Number(rawPage)) ? Number(rawPage) : 0
  const rawPageSize = searchParams.get('pageSize')
  const pageSize = rawPageSize !== null && !isNaN(Number(rawPageSize)) ? Number(rawPageSize) : 25
  return { page, pageSize }
}
